<template>
  <div id="app" class="hero">
    <div
      v-if="!this.isHealth"
      v-bind:class="{ 'slideout-active': isMenuExpanded }"
    >
      <Ribbon v-if="!isProduction" :text="runtimeConfig.env" fixed />
      <Header
        v-if="newHeader"
        id="nav"
        :primaryNav="headerPrimaryNav"
        :secondaryNav="headerSecondaryNav"
        :museumInfo="headerMuseumInfo"
        :sticky="true"
        :hasSearch="true"
      />
      <OldHeader
        v-if="!newHeader"
        class="hero-header"
        :route="whichRoute"
        :mobile="isMobile"
        :info="GettyHeader"
        v-on:update:toggle:menu="toggleMenu()"
      />
      <SearchOverlay />
      <div
        v-if="whichNodeEnv === 'development'"
        class="hero-header"
        :class="whichRoute"
      >
        <h2 style="text-align: center;">Dev Menu - Not on live</h2>
        <router-link :to="{ name: 'global' }">Global Search</router-link> |
        <router-link :to="{ name: 'gci' }">GCI Search</router-link> |
        <router-link :to="{ name: 'gcipub' }">
          GCI Publications Search
        </router-link>
        |
        <router-link :to="{ name: 'museumed' }">
          Museum Education
        </router-link>
        |
        <router-link :to="{ name: 'virtuallibrary' }"
          >Virtual Library</router-link
        >
        | <router-link :to="{ name: 'go' }">GO</router-link> |
        <router-link :to="{ name: 'kim' }">
          Keeping It Modern Report Search
        </router-link>
      </div>
      <router-view class="body" :isMobile="isMobile" />
      <Footer
        :baseUrl="baseUrl"
        :primaryNav="footerPrimaryNav"
        :museumInfo="footerMuseumInfo"
        :navGrid="footerNavGrid"
        :social="footerSocial"
        :socialAllLink="footerSocialAllLink"
      />
    </div>
    <div v-else>
      <router-view />
    </div>
    <Slideout
      :info="GettyHeader.GettyMobileNav"
      v-if="isMenuExpanded"
      v-on:update:close:menu="toggleMenu()"
    />
  </div>
</template>

<script>
import OldHeader from "@/components/Header.vue";
import HeaderInfo from "@/assets/header.json";
import Slideout from "@/components/Slideout";
import HeaderData from "@thegetty/getty-ui/src/components/globals/header/data.json";
// import FooterData from "@thegetty/getty-ui/src/components/globals/footer/data.json";
import FooterData from "@/assets/footer.json"; // workaround until `getty-ui` has the updated closure info

export default {
  name: "app",
  data() {
    return {
      baseUrl: "https://www.getty.edu",
      headerPrimaryNav: HeaderData.primaryNav,
      headerSecondaryNav: HeaderData.secondaryNav,
      headerMuseumInfo: HeaderData.museumInfo,
      footerPrimaryNav: FooterData.primaryNav,
      footerMuseumInfo: FooterData.museumInfo,
      footerNavGrid: FooterData.navGrid,
      footerSocial: FooterData.social,
      footerSocialAllLink: FooterData.socialAllLink,
      isMenuExpanded: false,
      GettyHeader: HeaderInfo,
      newHeader: true,
      windowWidth: window.innerWidth
    };
  },
  metaInfo: {
    charset: "utf-8",
    titleTemplate: "Getty | %s",
    meta: [
      {
        name: "descrption",
        content:
          "Visit our Los Angeles museums and library, interact with art, and access free research tools."
      },
      {
        name: "robots",
        content: "noindex,nofollow"
      }
    ]
  },
  components: {
    OldHeader,
    Slideout
  },
  inject: ["runtimeConfig"],
  computed: {
    whichRoute() {
      if (!this.$route) return "/";
      return this.$route.name;
    },
    isMobile() {
      return this.whichRoute === "go"
        ? this.windowWidth <= 767
        : this.windowWidth <= 987;
    },
    isHealth() {
      if (this.$route?.path.includes("/health")) {
        return true;
      } else {
        return false;
      }
    },
    isProduction() {
      return this.runtimeConfig.env === "prod";
    },
    whichNodeEnv() {
      return process.env.NODE_ENV;
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === "global") {
        this.newHeader = true;
      } else {
        this.newHeader = false;
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.setWindowWidth);
  },
  destroyed() {
    window.removeEventListener("resize", this.setWindowWidth);
  },
  methods: {
    setWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    toggleMenu() {
      this.isMenuExpanded = !this.isMenuExpanded;
    }
  }
};
</script>

<style src="@thegetty/getty-ui/dist/getty-ui.css"></style>

<style lang="scss">
html,
body {
  font-size: $standard-em;
  background-color: $light-gray;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0 auto;
  // overflow: hidden;
  width: 100%;
  position: relative;
  background-color: #fff;
}
#nav {
  color: $white;
  background-color: #1a47b8;
  a {
    color: $white;
  }
}
.hero-header {
  margin: 0 auto;
  text-align: center;
  width: 986px;
  &.home,
  &.global {
    background: #1a47b8;
    color: $white;
    width: 100%;
    a {
      color: $white;
    }
  }
}
highlight {
  background-color: #f9f9a3;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-align: left;
}
h4 {
  a {
    color: #808080;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
.icon-getty-hamburger,
.icon-getty-logo {
  font-family: GettyWeb;
  font-weight: 400;
  font-style: normal;
  text-decoration: inherit;
  line-height: 0.75;
}
.icon-getty-logo {
  color: $black-ter;
  padding-top: 5px;
  &:before {
    content: "\e603";
    font-size: 32px;
    margin-left: 2px;
  }
}
.icon-getty-hamburger {
  &:before {
    content: "\e61b";
  }
}
.slideout {
  box-shadow: inset 7px 0 9px -7px rgba(0, 0, 0, 1);
  &-active {
    width: calc(100% - 20em);
  }
}
.body {
  margin: 0 auto;
  .fit,
  &.fit {
    margin: 0 auto;
    width: 986px;
    &.columns {
      margin: 0 auto;
    }
  }
}
.g-mobile-navigation {
  color: $black;
  &__info,
  &__nav {
    a {
      color: $black !important;
    }
  }
}
.g-footer {
  color: $black;
  padding-left: 3.75em;
  padding-right: 3.75em;
  width: 100%;
  &__social {
    right: 3.75em;
  }
}
.m-navigation__search {
  color: $white;
}
@media screen and (max-width: $desktop) {
  .hero-header {
    width: auto;
  }
  .body {
    margin: 0;
    width: auto;
    .fit,
    &.fit {
      width: 100%;
    }
  }
  .g-footer {
    padding-left: 1em;
    padding-right: 1em;
    &__social {
      right: 1em;
    }
  }
}
@media screen and (max-width: $tablet) {
  #nav a {
    color: inherit;
  }
  .g-footer {
    &__social {
      left: 1em;
      right: 0;
    }
  }
}
</style>
